import { AuthorizationException, AuthenticationException } from "@pjn/core/error";
/**
 * Servicio de Seguridad, permite hacer login, logout, obtener datos del usuario y ver sus permisos.
 *
 * Para todo esto, utiliza el security provider que se especifica (ej: Keycloak).
 */
export default class AuthService {
    constructor(securityProvider, config) {
        this.securityProvider = securityProvider;
        this.config = config;
    }
    getUser() {
        return this.securityProvider.getUser();
    }
    isAllowed(permission, checkGlobal = false) {
        return this.securityProvider.isAllowed(permission, checkGlobal);
    }
    get applicationRoles() {
        return this.securityProvider.getApplicationRoles();
    }
    get globalRoles() {
        return this.securityProvider.getGlobalRoles();
    }
    get authenticated() {
        return this.securityProvider.authenticated;
    }
    get canAccess() {
        return this.isAllowed(this.config.accessPermissionName);
    }
    async loadUserIfAuthenticated() {
        const authenticated = await this.check();
        if (authenticated)
            await this.login();
        return authenticated;
    }
    async check() {
        await this.securityProvider.start(false);
        return this.authenticated;
    }
    async login() {
        try {
            await this.securityProvider.login();
            if (!this.canAccess) {
                throw new AuthorizationException({ code: "acceso_no_autorizado", message: "El usuario no tiene permiso para acceder a la aplicacion" });
            }
            const user = this.getUser();
            if (!user)
                throw new Error();
            console.info("Autenticacion con SSO exitosa. Usuario: %s", user.username);
            return user;
        }
        catch (e) {
            if (e instanceof AuthorizationException) {
                window.location.href = `${this.config.unauthorizedUrl}?app=${encodeURIComponent(this.config.appTitle)}`;
                throw e;
            }
            window.location.href = this.config.unexpectedErrorUrl;
            throw new AuthenticationException({ code: "usuario_no_autenticado", message: "Error al autenticar al usuario" });
        }
    }
    async logout() {
        // let currentUrl = location.href.replace("/logout","");
        try {
            await this.securityProvider.logout( /*{redirectUri: currentUrl}*/);
        }
        catch (e) {
            console.error("Error al hacer logout en el SSO", e);
            throw new AuthenticationException({ code: "authentication_error", message: "Error al hacer logout en el SSO" });
        }
    }
}
//# sourceMappingURL=AuthService.js.map